import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Spinner } from "../ui/spinner";

interface FullscreenLoadingProps {
  children?: ReactNode;
  isVisible: boolean;
}

const DEFAULT_LOADING_MESSAGE_KEY = "fullscreenLoading.defaultMessage";

const FullscreenLoading = ({ children, isVisible }: FullscreenLoadingProps) => {
  // No suspense: this component is also the app's <Suspense> fallback and must
  // paint immediately, before translation catalogs finish loading.
  const { t } = useTranslation(undefined, { useSuspense: false });

  if (!isVisible) {
    return null;
  }

  const loadingMessage = children ?? t(DEFAULT_LOADING_MESSAGE_KEY, "Loading…");

  return (
    <main
      aria-busy="true"
      aria-live="polite"
      className="fixed inset-0 z-99999 flex min-h-screen items-center justify-center bg-background"
    >
      <div className="flex flex-col items-center gap-3 text-center text-muted-foreground">
        <Spinner className="size-16 text-primary" />
        <div>{loadingMessage}</div>
      </div>
    </main>
  );
};

export type { FullscreenLoadingProps };

export { FullscreenLoading };
